import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: '0.05px',
    overflow: 'visible',
  },
  button: {
    margin: theme.spacing(1),
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  table: {
    marginTop: 0,
  },
  createTaskItemButton: {
    minHeight: 42,
    margin: theme.spacing(0, 0, 1.5),
    padding: theme.spacing(0.75, 2),
    borderRadius: 14,
    textTransform: 'none',
    fontWeight: 700,
    letterSpacing: '0.01em',
    background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 52%, #60a5fa 100%)',
    boxShadow: '0 14px 30px rgba(37, 99, 235, 0.24)',
    transition:
      'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, background-color 180ms ease',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 10px 18px rgba(15, 23, 42, 0.1)',
    },
  },
}));

export default useStyles;
